import React, { useEffect, useState } from "react";
// import { TfiReload } from 'react-icons/tfi';
import $ from "jquery";
import "react-datepicker/dist/react-datepicker.css";
import { dateFormatOKX, showPairNameUsdt } from '../../../core/helper/date-format';
import { Link, useNavigate } from "react-router-dom";
// import Pagination from 'react-responsive-pagination';
import '../../../pagination.css';
import '../../../assets/style.css';
import '../../../assets/styledev.css';
// import AddTpSl from "./dialogsUsdt/AddTpSlUsdt";
import { styled } from '@mui/material/styles';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// import AlertDialog from "./dialogsUsdt/CloseConfirmationUsdt";
import LoaderSpin from "../../../Component/Loader/LoaderSpin";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    background: 'transparent', color: 'rgb(243, 243, 243)', width: '100%'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
  padding: "10px 4px"
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    background: 'transparent', color: 'rgb(243, 243, 243)'
  },
  background: 'transparent', color: 'rgb(243, 243, 243)',
  // hide last border
  'td,th': {
    border: 0,
  },
}));

export default function SpotMyOrdersUsdt(props) {
  const {
    myProfile = {},
    trades = {
      openOrders: [], stopOrders: [], orders: [], fills: []
    },
    tradesBackPage,
    symbolsData = [],
    countDecimals,
    cancelOrder,
    pairsLoader,
    orderFetchLoading,
    openOrdersDataFetch,
    orderHistoryDataFetch,
    stopOrderDataFetch,
    fillsOrderDataFetch
  } = props;
  const navigate = useNavigate();
  const [userHistoryTab, setUserHistoryTab] = useState("Open Orders");
  useEffect(() => {
    $(".status_change .dropdown-item").click(function () {
      var getStatusText = $(this).text();
      $(this).closest(".status_dropdown").find(".status__btn").text(getStatusText);
      var generateStatusClass = `${$(this).attr('data-class')}-status`
      $(this).closest(".status_dropdown").attr("data-color", `${generateStatusClass}`);
    })
  }, []);
  // const copyText = (data = {}) => {
  //   if (data.text) {
  //     var input = document.createElement("input");
  //     document.body.appendChild(input);
  //     input.value = data.text;
  //     input.select();
  //     document.execCommand("Copy");
  //     input.remove();
  //     toast({ type: "success", message: data.message });
  //   }
  // }
  return (
    <div>

      <div className='d-flex flex-row trading-page-order-details-section '>
        <div className='col-12'>
          <div className="d-flex justify-content-start paired-trade-table-section align-items-center py-3 py-sm-3 py-md-3 py-lg-0">
            <div className="">
              <ul className="nav nav-pills" id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation" onClick={() => setUserHistoryTab("Open Orders")}>
                  <button
                    className="nav-link active"
                    id="pills-openorders-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-openorders"
                    type="button" role="tab"
                    aria-controls="pills-openorders"
                    aria-selected="false"
                  >
                    Open Orders ({trades?.openOrders?.list?.length || 0})
                  </button>
                </li>

                <li className="nav-item" role="presentation" onClick={() => setUserHistoryTab("Stop Orders")}>
                  <button
                    className="nav-link"
                    id="pills-positionhistory-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-positionhistory"
                    type="button"
                    role="tab"
                    aria-controls="pills-positionhistory"
                    aria-selected="false"
                  >
                    Stop Orders ({trades?.stopOrders?.list?.length || 0})
                  </button>
                </li>
                <li className="nav-item" role="presentation" onClick={() => setUserHistoryTab("Order History")}>
                  <button
                    className="nav-link"
                    id="pills-orderhistory-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-orderhistory"
                    type="button"
                    role="tab"
                    aria-controls="pills-orderhistory"
                    aria-selected="false"
                  >
                    Order History
                  </button>
                </li>
                <li className="nav-item" role="presentation" onClick={() => setUserHistoryTab("Trade History")}>
                  <button
                    className="nav-link"
                    id="pills-positionhistory-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-positionhistory"
                    type="button"
                    role="tab"
                    aria-controls="pills-positionhistory"
                    aria-selected="false"
                  >
                    Trade History
                  </button>
                </li>
              </ul>
            </div>

          </div>

          {(!myProfile && !myProfile?._id)
            ?
            <div className='trading-page-order-tabs-section pt-5'>
              <span className='trade-bottom-login-text-1'>
                <span className='fc-g cursor-pointer' onClick={() => navigate('/login')}>Login </span>(or)
                <span className='fc-g cursor-pointer' onClick={() => navigate('/register')}> Register Now</span> to trade
              </span>
            </div>
            : (pairsLoader || orderFetchLoading) ? <div className='trading-page-order-tabs-section pt-3'><LoaderSpin /></div> :
              <>
                <div className="trading-page-order-table-details-section" style={{ height: '30vh', overflow: 'auto', borderRight: '1px solid rgb(238, 240, 242)' }}>
                  {userHistoryTab == "Open Orders" ?
                    <TableContainer>
                      <Table sx={{ minWidth: window.innerWidth < 700 ? 900 : 850, justifyContent: 'center' }} aria-label="customized table" stickyHeader >
                        <TableHead>
                          <TableRow>
                            <StyledTableCell>Time</StyledTableCell>
                            <StyledTableCell>Pair</StyledTableCell>
                            <StyledTableCell>Type</StyledTableCell>
                            <StyledTableCell>Side</StyledTableCell>
                            <StyledTableCell>Price</StyledTableCell>
                            <StyledTableCell>Amount</StyledTableCell>
                            <StyledTableCell>Filled</StyledTableCell>
                            <StyledTableCell>Unfilled</StyledTableCell>
                            <StyledTableCell>Cancel All</StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody sx={{
                          '&.MuiTableBody-root': {
                            height: '100%',
                          }
                        }}>
                          {trades?.openOrders?.list?.length > 0 && trades?.openOrders?.list.map((elem, i) => {
                            // if (elem.type !== 'limit' || elem.type !== 'market') return null;
                            const { orderId = null, symbol = '', type = '', price = '0', qty = 0, side = '', createdTime = null, orderType = '', leavesQty = '0' } = elem

                            const clrClassName = side == 'Buy' ? 'color-green-futures' : 'color-red-futures';
                            return <StyledTableRow key={i}>
                              <StyledTableCell>{dateFormatOKX(createdTime)}</StyledTableCell>
                              <StyledTableCell>{symbol ?
                                <Link to={"/spot-usdt/" + showPairNameUsdt(symbol, '-')} className="text-white">{showPairNameUsdt(symbol)}</Link> : ""
                              }</StyledTableCell>
                              <StyledTableCell className={"capitalizeText "}>{orderType || type}</StyledTableCell>
                              <StyledTableCell className={"capitalizeText " + (clrClassName)}>{side}</StyledTableCell>
                              <StyledTableCell>{price} {showPairNameUsdt(symbol, '-')?.split('-')?.[1]}</StyledTableCell>
                              <StyledTableCell>{qty} {showPairNameUsdt(symbol, '-')?.split('-')?.[0]}</StyledTableCell>
                              <StyledTableCell>{Number(qty) - Number(leavesQty)} {showPairNameUsdt(symbol, '-')?.split('-')?.[0]}</StyledTableCell>
                              <StyledTableCell>{leavesQty || '0'} {showPairNameUsdt(symbol, '-')?.split('-')?.[0]}</StyledTableCell>
                              <StyledTableCell><div className="d-flex justify-content-start"><button type="button" className="market-trade-button px-1" onClick={async () => await cancelOrder(true, { orderId, symbol, category: 'spot', orderFilter: 'Order' })}>Cancel</button></div></StyledTableCell>
                            </StyledTableRow>
                          })}
                          {trades?.openOrders?.list?.length == 0 &&
                            <StyledTableRow>
                              <StyledTableCell className='text-white'>No Active Orders Found!</StyledTableCell>
                            </StyledTableRow>
                          }
                          <StyledTableRow>
                            <div className="d-flex justify-content-start align-items-center pt-3 pb-2" style={{ gap: '10px' }}>
                              {
                                tradesBackPage?.openOrders ?
                                  <button type="button" className="market-trade-button ps-2 pe-3" onClick={() => openOrdersDataFetch('1')}><NavigateBeforeIcon fontSize="small" />Back To First Page</button> : null
                              }
                              {
                                (trades?.openOrders?.nextPageCursor && trades?.openOrders?.list?.length == trades.dataLimit) ? <button type="button" className="market-trade-button ps-3 pe-2" onClick={() => openOrdersDataFetch(trades?.openOrders?.nextPageCursor)}>Next Page<NavigateNextIcon fontSize="small" /></button> : null
                              }
                            </div>
                          </StyledTableRow>
                        </TableBody>
                      </Table>
                    </TableContainer> : null
                  }
                  {userHistoryTab == "Order History" ?
                    <TableContainer>
                      <Table sx={{ minWidth: window.innerWidth < 700 ? 900 : 1000, justifyContent: 'center' }} aria-label="customized table" stickyHeader size='small'>
                        <TableHead>
                          <TableRow>
                            <StyledTableCell>Time</StyledTableCell>
                            <StyledTableCell>Pair</StyledTableCell>
                            {/* <StyledTableCell>Type</StyledTableCell> */}
                            <StyledTableCell>Side</StyledTableCell>
                            {/* <StyledTableCell>Trigger Condition</StyledTableCell> */}
                            <StyledTableCell>Price</StyledTableCell>
                            {/* <StyledTableCell>Amount</StyledTableCell> */}
                            <StyledTableCell>Total</StyledTableCell>
                            <StyledTableCell>Fees</StyledTableCell>
                            <StyledTableCell>Fee Type</StyledTableCell>
                            <StyledTableCell>Status</StyledTableCell>
                            {/* <StyledTableCell>Action</StyledTableCell> */}
                          </TableRow>
                        </TableHead>
                        <TableBody sx={{
                          '&.MuiTableBody-root': {
                            height: '100%',
                          }
                        }}>
                          {trades?.orders?.list?.length > 0 && trades?.orders?.list.map((elem, i) => {
                            // if (elem?.status === 'active' || elem?.status === 'open' || elem?.isActive === 'true' || elem?.isActive === true) { return null }

                            const { side = '', symbol = '', createdTime = '', price = '', orderStatus = '', cumFeeDetail = {}, qty = '', leavesQty = '' } = elem;

                            const clrClassName = side === 'Buy' ? 'color-green-futures' : 'color-red-futures';
                            return <StyledTableRow key={i}>
                              <StyledTableCell>{dateFormatOKX(createdTime)}</StyledTableCell>
                              <StyledTableCell>{symbol ?
                                <Link to={"/spot-usdt/" + showPairNameUsdt(symbol, '-')} className="text-white">{showPairNameUsdt(symbol)}</Link> : ""
                              }</StyledTableCell>
                              <StyledTableCell className={"capitalizeText " + (clrClassName)}>{side}</StyledTableCell>
                              <StyledTableCell>{price} {showPairNameUsdt(symbol, '-')?.split('-')?.[1]}</StyledTableCell>
                              <StyledTableCell>{Number(qty) - Number(leavesQty)} {showPairNameUsdt(symbol, '-')?.split('-')?.[0]}</StyledTableCell>
                              <StyledTableCell>
                                {Object.keys(cumFeeDetail || {}).length > 0
                                  ? Object.entries(cumFeeDetail).map(([coin, fee]) => `${fee} ${coin}`).join(', ')
                                  : '0'}
                              </StyledTableCell>
                              <StyledTableCell>Maker</StyledTableCell>
                              {/* <StyledTableCell data-label="Status" className="capitalizeText">{(!isActive && (cancelExist || +(canceledSize) > 0)) ? 'cancelled' : (type.toLowerCase() === 'triggered' || type.toLowerCase() === 'cancel') ? type.toLowerCase() === 'cancel' ? 'cancelled' : type : 'filled'}</StyledTableCell> */}
                              <StyledTableCell data-label="Status" className="capitalizeText">{orderStatus}</StyledTableCell>
                            </StyledTableRow>
                          })}
                          {trades?.orders?.list?.length == 0 &&
                            <StyledTableRow>
                              <StyledTableCell className='text-white'>No History Found!</StyledTableCell>
                            </StyledTableRow>
                          }
                          <StyledTableRow>
                            <div className="d-flex justify-content-start align-items-center pt-3 pb-2" style={{ gap: '10px' }}>
                              {
                                tradesBackPage?.orders ?
                                  <button type="button" className="market-trade-button ps-2 pe-3" onClick={() => orderHistoryDataFetch('1')}><NavigateBeforeIcon fontSize="small" />Back To First Page</button> : null
                              }
                              {
                                (trades?.orders?.nextPageCursor && trades?.orders?.list?.length == trades.dataLimit) ? <button type="button" className="market-trade-button ps-3 pe-2" onClick={() => orderHistoryDataFetch(trades?.orders?.nextPageCursor)}>Next Page<NavigateNextIcon fontSize="small" /></button> : null
                              }
                            </div>
                          </StyledTableRow>
                        </TableBody>
                      </Table>
                    </TableContainer> : null
                  }
                  {userHistoryTab == "Stop Orders" ?
                    <TableContainer>
                      <Table sx={{ minWidth: window.innerWidth < 700 ? 900 : 1000, justifyContent: 'center' }} aria-label="customized table" stickyHeader size='small'>
                        <TableHead>
                          <TableRow>
                            <StyledTableCell>Time</StyledTableCell>
                            <StyledTableCell>Pair</StyledTableCell>
                            <StyledTableCell>Type</StyledTableCell>
                            <StyledTableCell>Side</StyledTableCell>
                            <StyledTableCell>Trigger Condition</StyledTableCell>
                            <StyledTableCell>Stop Price</StyledTableCell>
                            <StyledTableCell>Price</StyledTableCell>
                            <StyledTableCell>Amount</StyledTableCell>
                            <StyledTableCell>Cancel All</StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody sx={{
                          '&.MuiTableBody-root': {
                            height: '100%',
                          }
                        }}>
                          {trades?.stopOrders?.list?.length > 0 && trades?.stopOrders?.list.map((elem, i) => {
                            // if (elem.type !== 'limit_stop' || elem.type !== 'market_stop') return null;
                            const { orderId = null, symbol = '', triggerPrice = '0', price = '0', qty = '0', side = '', createdTime = null, orderStatus = '--', stopOrderType = '--', orderType = '--'
                            } = elem;
                            const clrClassName = side == 'Buy' ? 'color-green-futures' : 'color-red-futures';
                            // const symbolDetails = symbolsData[symbol]
                            // const priceDecimal = countDecimals(symbolDetails?.priceFilter?.tickSize)
                            // const baseDecimal = countDecimals(symbolDetails?.lotSizeFilter?.basePrecision)
                            return <StyledTableRow key={i}>
                              <StyledTableCell>{dateFormatOKX(createdTime)}</StyledTableCell>
                              <StyledTableCell>{symbol ?
                                <Link to={"/spot-usdt/" + showPairNameUsdt(symbol, '-')} className="text-white">{showPairNameUsdt(symbol)}</Link> : ""
                              }</StyledTableCell>
                              <StyledTableCell className={"capitalizeText "}>{stopOrderType}{" "}{orderType}</StyledTableCell>
                              <StyledTableCell className={"capitalizeText " + (clrClassName)}>{side}</StyledTableCell>
                              <StyledTableCell className={"capitalizeText "}>{orderStatus}</StyledTableCell>
                              {/* <StyledTableCell>{(+triggerPrice).toFixed(priceDecimal || 2)}</StyledTableCell>
                              <StyledTableCell>{(+price).toFixed(priceDecimal || 2)}</StyledTableCell>
                              <StyledTableCell>{(+qty).toFixed(baseDecimal || 2)}</StyledTableCell> */}
                              <StyledTableCell>{triggerPrice}</StyledTableCell>
                              <StyledTableCell>{price}</StyledTableCell>
                              <StyledTableCell>{qty}</StyledTableCell>
                              <StyledTableCell><div className="d-flex justify-content-start"><button type="button" className="market-trade-button px-1" onClick={async () => await cancelOrder(true, { orderId, symbol, category: 'spot', orderFilter: 'StopOrder' })}>Cancel</button></div></StyledTableCell>
                            </StyledTableRow>
                          })}
                          {trades?.stopOrders?.list?.length == 0 &&
                            <StyledTableRow>
                              <StyledTableCell className='text-white'>No Stop Orders Found!</StyledTableCell>
                            </StyledTableRow>
                          }
                          <StyledTableRow>
                            <div className="d-flex justify-content-start align-items-center pt-3 pb-2" style={{ gap: '10px' }}>
                              {
                                tradesBackPage?.stopOrders ?
                                  <button type="button" className="market-trade-button ps-2 pe-3" onClick={() => stopOrderDataFetch('1')}><NavigateBeforeIcon fontSize="small" />Back To First Page</button> : null
                              }
                              {
                                (trades?.stopOrders?.nextPageCursor && trades?.stopOrders?.list?.length == trades.dataLimit) ? <button type="button" className="market-trade-button ps-3 pe-2" onClick={() => stopOrderDataFetch(trades?.stopOrders?.nextPageCursor)}>Next Page<NavigateNextIcon fontSize="small" /></button> : null
                              }
                            </div>
                          </StyledTableRow>
                        </TableBody>
                      </Table>
                    </TableContainer> : null
                  }
                  {userHistoryTab == "Trade History" ?
                    <TableContainer>
                      <Table sx={{ minWidth: window.innerWidth < 700 ? 900 : 1000, justifyContent: 'center' }} aria-label="customized table" stickyHeader size='small'>
                        <TableHead>
                          <TableRow>
                            <StyledTableCell>Time Filled</StyledTableCell>
                            <StyledTableCell>Pair</StyledTableCell>
                            <StyledTableCell>Type</StyledTableCell>
                            <StyledTableCell>Side</StyledTableCell>
                            <StyledTableCell>Fill Price</StyledTableCell>
                            <StyledTableCell>Amount</StyledTableCell>
                            <StyledTableCell>Trade Type</StyledTableCell>
                            <StyledTableCell>Fee</StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody sx={{
                          '&.MuiTableBody-root': {
                            height: '100%',
                          }
                        }}>
                          {trades?.fills?.list?.length > 0 && trades?.fills?.list.map((elem, i) => {
                            // if (elem?.status !== 'done') { return null }

                            const { side = '', symbol = '', execQty = '0', execFeeV2 = '0', execTime = '', execPrice = '', feeCurrency = '', orderType = '', execType = '' } = elem;

                            const clrClassName = side === 'Buy' ? 'color-green-futures' : 'color-red-futures';
                            return <StyledTableRow key={i}>
                              <StyledTableCell>{dateFormatOKX(execTime)}</StyledTableCell>
                              <StyledTableCell>{symbol ?
                                <Link to={"/spot-usdt/" + showPairNameUsdt(symbol, '-')} className="text-white">{showPairNameUsdt(symbol)}</Link> : ""
                              }</StyledTableCell>
                              <StyledTableCell className={"capitalizeText "}>{orderType ? orderType : '--'}</StyledTableCell>
                              <StyledTableCell className={"capitalizeText " + (clrClassName)}>{side ? side : '--'}</StyledTableCell>
                              <StyledTableCell>{execPrice ? execPrice : '--'}</StyledTableCell>
                              <StyledTableCell>{execQty ? execQty : '--'}</StyledTableCell>
                              <StyledTableCell>{execType ? execType : '--'}</StyledTableCell>
                              <StyledTableCell>{execFeeV2 ? execFeeV2 + ' ' : '--'}{feeCurrency ? feeCurrency : ''}</StyledTableCell>
                            </StyledTableRow>
                          })}
                          {trades?.fills?.list?.length == 0 &&
                            <StyledTableRow>
                              <StyledTableCell className='text-white'>No Fills Found!</StyledTableCell>
                            </StyledTableRow>
                          }<StyledTableRow>
                            <div className="d-flex justify-content-start align-items-center pt-3 pb-2" style={{ gap: '10px' }}>
                              {
                                tradesBackPage?.fills ?
                                  <button type="button" className="market-trade-button ps-2 pe-3" onClick={() => fillsOrderDataFetch('1')}><NavigateBeforeIcon fontSize="small" />Back To First Page</button> : null
                              }
                              {
                                (trades?.fills?.nextPageCursor && trades?.fills?.list?.length == trades.dataLimit) ? <button type="button" className="market-trade-button ps-3 pe-2" onClick={() => fillsOrderDataFetch(trades?.fills?.nextPageCursor)}>Next Page<NavigateNextIcon fontSize="small" /></button> : null
                              }
                            </div>
                          </StyledTableRow>
                        </TableBody>
                      </Table>
                    </TableContainer> : null
                  }
                </div>
              </>

          }
        </div>
      </div>

    </div>
  );
}
